const getters = {
    task: (state) => state.task,
    id: (state) => state.id,
    taskbyleadid: (state) => state.taskbyleadid,
    loading: state => state.loading
};

export default getters;